// extracted by mini-css-extract-plugin
export var container = "gallery-module--container--98sgL";
export var slideInner = "gallery-module--slide-inner--tMe4E";
export var slideImageWrapper = "gallery-module--slide-image-wrapper--q0suq";
export var slideImage = "gallery-module--slide-image--zNZNw";
export var slideDescription = "gallery-module--slide-description--J+fhE";
export var slideDescriptionParagraph = "gallery-module--slide-description-paragraph--WsR6u";